import Axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from "axios";
import { GetUsersDTO } from "../redux//users";
import { AlertStatus } from "../redux/alerts";
import {
  loginDTO,
  signInPasswordlessDTO,
  signInPasswordlessEndDTO,
} from "../redux/auth";
import { devicesReqOptions } from "../redux/devices";
import {
  notifyLoginLogoutDTO,
  subscribeData,
  subscribeMobileDeviceDTO,
  unsubscribeData,
  unsubscribeMobileDeviceDTO,
  updateData,
} from "../redux/healthCheck/index";
import {
  GetFeedbackDTO,
  GetFeedbackResponceDTO,
  SetAlertTypeDTO,
} from "../redux/modalFeedback/index";
import { SendActivityDTO } from "../redux/residentActivityPlan";
import { residentsReqOptions } from "../redux/residents";
import { notificationsSettings } from "../redux/userProfile";
import { EndPoints } from "../saga/endPoints";
import { StorageHelper } from "../utils/StorageHelper";

class _Axios {
  private _axios: AxiosInstance;

  get headersPrivate() {
    return {
      Authorization: "Bearer " + StorageHelper.instance.GetAccessToken(),
      Accept: "application/json",
      "Content-Type": "application/json",
    };
  }

  get headersFormData() {
    return {
      Authorization: "Bearer " + StorageHelper.instance.GetAccessToken(),
      Accept: "application/json",
      // Accept: 'application/json',
      // 'Content-Type': 'multipart/form-data;boundary="boundary"',
      // 'Content-Disposition': 'form-data; name="file"',
      "Content-Type": "multipart/form-data",
      // 'Content-Disposition': 'form-data',
    };
  }

  constructor(config?: AxiosRequestConfig) {
    this._axios = Axios.create(config);
    //  this._axios.defaults.timeout = 5000;
    this._axios.interceptors.response.use(
      this.responceSuccsess,
      this.responceReject
    );
  }

  private responceSuccsess = (response: AxiosResponse<any>) => {
    return response;
  };

  private isTokenExpiredError(error: AxiosError): boolean {
    return error?.response?.status === 401;
  }
  private responceReject = (error: any) => {
    return Promise.reject(error);
  };

  validateToken = (payload: string): Promise<AxiosResponse<any>> => {
    const headers = {
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    const config = {
      headers: headers,
    };
    return this._axios.get(
      EndPoints.validateTokenURL(payload).toString(),
      config
    );
  };

  getOrganizationInfo = () => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(EndPoints.organizationsURL().toString(), config);
  };

  getOrganizationInfoByID = () => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(
      EndPoints.organizationsInfoByIdURL().toString(),
      config
    );
  };

  getUsersProfile = () => {
    const config = {
      headers: this.headersPrivate,
      params: {
        include: "role",
      },
    };
    return this._axios.get(EndPoints.usersProfileURL().toString(), config);
  };

  getUsers = (value: GetUsersDTO, id?: string): Promise<AxiosResponse<any>> => {
    const params = new URLSearchParams();
    if (value.includeRole) params.append("include", "role");
    if (value.includeActivityStatus) params.append("include", "activityStatus");
    if (id === undefined) params.append("items", "100");
    const config = {
      headers: this.headersPrivate,
      params: params,
    };

    return this._axios.get(EndPoints.getUsersURL().toString(), config);
  };

  sendActivity = () => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.post(EndPoints.activityURL().toString(), {}, config);
  };

  getFeedbackByAlertType = (value: GetFeedbackDTO) => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(
      EndPoints.alertsURL(value.residentId, value.alertType).toString(),
      config
    );
  };

  setAlertByType = (value: SetAlertTypeDTO) => {
    const config = {
      headers: this.headersPrivate,
    };
    const changeMe: GetFeedbackResponceDTO = {
      ...value.alert,
      status: AlertStatus.done,
    };
    return this._axios.put(
      EndPoints.alertsURL(value.residentId, value.alertToken).toString(),
      changeMe,
      config
    );
  };

  getResidents = (options: residentsReqOptions) => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(EndPoints.residentsURL(options).toString(), config);
  };

  getDevices = (options: devicesReqOptions) => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(EndPoints.getDevicesURL(options).toString(), config);
  };

  getUserTagDevices = (options: devicesReqOptions) => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(EndPoints.userTags().toString(), config);
  };

  changeLanguage = (value: any) => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.post(EndPoints.languageUrl().toString(), value, config);
  };
  /** -------------------------------old section-----------------------------  */

  registerNotification = (options: subscribeData) => {
    const config = {
      headers: this.headersPrivate,
    };
    const { mobileId, ...rest } = options;
    return this._axios.post(
      EndPoints.notificationUrl(mobileId).toString(),
      rest,
      config
    );
  };

  unregisterNotification = (data: unsubscribeData) => {
    return this._axios.delete(
      EndPoints.notificationUrl(data.mobileId).toString(),
      {
        headers: this.headersPrivate,
      }
    );
  };

  updateNotification = (dataFrom: updateData) => {
    const { mobileId, nodeIds, token, tokenType } = dataFrom;
    const data = token ? { nodeIds, token, tokenType } : { nodeIds };
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.put(
      EndPoints.notificationUrl(mobileId).toString(),
      { ...data },
      config
    );
  };

  checkNotification = (deviceId: string) => {
    return this._axios.get(EndPoints.notificationUrl(deviceId).toString(), {
      headers: this.headersPrivate,
    });
  };

  notifyLogin = (value: notifyLoginLogoutDTO) => {
    return this._axios.post(EndPoints.notifyLoginUrl().toString(), value, {
      headers: this.headersPrivate,
    });
  };
  notifyLogout = (value: notifyLoginLogoutDTO) => {
    return this._axios.post(EndPoints.notifyLogoutUrl().toString(), value, {
      headers: this.headersPrivate,
    });
  };

  getRepeatAlertSettings = (orgId: number) => {
    return this._axios.get(EndPoints.repeatAlertURL(orgId).toString(), {
      headers: this.headersPrivate,
    });
  };

  getResidentsActivities = (startDate: string, endDate: string) => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(
      EndPoints.residentsActivitiesURL({ startDate, endDate }).toString(),
      config
    );
  };

  getResidentsConfigurations = () => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(
      EndPoints.residentActivityConfigURL().toString(),
      config
    );
  };

  sendResidentActivity = (dto: SendActivityDTO) => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.post(
      EndPoints.residentActivity().toString(),
      dto,
      config
    );
  };

  getActivitiesFeedbackOptions = () => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(EndPoints.activitiesFeedback().toString(), config);
  };

  getResidentsPictures = () => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(EndPoints.residentPicture().toString(), config);
  };

  getUsersPictures = () => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(EndPoints.usersAvatar().toString(), config);
  };

  userNotification = (userId: string, value: notificationsSettings) => {
    return this._axios.put(
      EndPoints.userNotification(userId).toString(),
      value,
      {
        headers: this.headersPrivate,
      }
    );
  };

  getVitalsUserNearby = () => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(EndPoints.getVitalsUserNearby().toString(), config);
  };
  getNodesNearbySettings = () => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(EndPoints.nodesNearbySettings().toString(), config);
  };

  getUserNearbyDeviceSettings = () => {
    return this._axios.get(EndPoints.vitalsUserNearbySettings().toString(), {
      headers: this.headersPrivate,
    });
  };

  getUsersMobileDevices = () => {
    return this._axios.get(EndPoints.userMobileDevice().toString(), {
      headers: this.headersPrivate,
    });
  };

  registerUserMobileDevices = (dto: subscribeMobileDeviceDTO) => {
    const { userId, ...rest } = dto;
    return this._axios.post(
      EndPoints.registerUserMobileDevice(userId).toString(),
      rest,
      {
        headers: this.headersPrivate,
      }
    );
  };

  unregisterUserMobileDevices = (dto: unsubscribeMobileDeviceDTO) => {
    const { userId, deviceId } = dto;
    return this._axios.delete(
      EndPoints.unregisterUserMobileDevice(userId, deviceId).toString(),
      {
        headers: this.headersPrivate,
      }
    );
  };
  ///auth
  getAuthData = () => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(EndPoints.getAuthData().toString(), config);
  };

  loginWithPassword = (dto: loginDTO) => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.post(EndPoints.loginPassword().toString(), dto, config);
  };

  loginPasswordlessFinish = (dto: signInPasswordlessEndDTO) => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.post(
      EndPoints.passwordlessEnd().toString(),
      dto,
      config
    );
  };
  loginPasswordlessStart = (dto: signInPasswordlessDTO) => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.post(
      EndPoints.passwordlessStart().toString(),
      dto,
      config
    );
  };

  logout = () => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.post(EndPoints.logout().toString(), {}, config);
  };

  signInCheck = (username: string) => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(
      EndPoints.signInCheck(encodeURIComponent(username)).toString(),
      config
    );
  };

  rotateToken = () => {
    const config = {
      headers: this.headersPrivate,
    };
    return this._axios.get(
      EndPoints.rotateToken(
        StorageHelper.instance.GetRefreshToken()
      ).toString(),
      config
    );
  };
}

const AxiosCustom = new _Axios(); //{ baseURL: EndPoints.local }
export { AxiosCustom };
